import "./select.scss";
import Typography from "../../Typography";
import Select, { components } from "react-select";
import InfiniteScroll from "react-infinite-scroll-component";

const SearchBar = (props) => {
  const {
    name,
    value,
    error,
    errorOnly,
    label,
    touch,
    onBlur,
    disabled,
    hintText,
    fullWidth,
    className,
    optionsList,
    noOptionText,
    placeholder,
    handleSelect,
    isSearchable,
    menuPlacement,
    classNamePrefix,
    menuCustomClassName,

    inputValue,
    onInputChange,

    onMenuClose,
    isSearching,
    hasMoreOptions,
    handleFetchMore,
    customClass,
  } = props;

  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span className="custom-css-class">{noOptionText || "No Options"}</span>
      </components.NoOptionsMessage>
    );
  };

  return (
    <div
      className={`sb-select-root${
        (error?.length && touch) || errorOnly?.length
          ? " sb-select-error-root"
          : ""
      }${fullWidth ? " sb-select-full-root" : ""}${
        customClass ? ` sb-select--${customClass}` : ""
      }`}
    >
      {label && <label>{label}</label>}
      <Select
        name={name}
        value={value}
        onBlur={onBlur}
        isClearable={true}
        isDisabled={disabled}
        options={optionsList}
        onChange={handleSelect}
        inputValue={inputValue}
        onMenuClose={onMenuClose}
        onInputChange={onInputChange}
        placeholder={value || placeholder}
        isSearchable={isSearchable ?? true}
        className={className || "sb-select"}
        menuPlacement={menuPlacement || "bottom"}
        classNamePrefix={classNamePrefix || "sb-select-prefix"}
        styles={{
          placeholder: (provided) => ({
            ...provided,
            color: value ? "#000" : "#a8b4b4",
          }),
        }}
        components={{
          NoOptionsMessage,
          Menu: (props) => (
            <CustomMenu
              {...props}
              value={value}
              inputValue={inputValue}
              isSearching={isSearching}
              optionsList={optionsList}
              handleSelect={handleSelect}
              hasMoreOptions={hasMoreOptions}
              handleFetchMore={handleFetchMore}
              menuCustomClassName={menuCustomClassName}
            />
          ),
        }}
      />
      {error?.length && touch ? (
        <p className="error-text">{error}</p>
      ) : hintText?.length ? (
        <p className="hint-text">{hintText}</p>
      ) : errorOnly?.length ? (
        <p className="error-text">{errorOnly}</p>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SearchBar;

const CustomMenu = (props) => {
  const {
    value,
    setValue,
    inputValue,
    optionsList,
    isSearching, // for initial search
    handleSelect,
    hasMoreOptions,
    handleFetchMore,
    menuCustomClassName,
  } = props;

  return (
    <div
      id="scrollableDiv"
      className={`sb-select-prefix__custom-menu${
        menuCustomClassName?.length > 0 ? ` ${menuCustomClassName}` : ""
      }`}
    >
      <InfiniteScroll
        scrollThreshold={0.9}
        next={handleFetchMore}
        hasMore={hasMoreOptions}
        scrollableTarget="scrollableDiv"
        dataLength={Array.isArray(optionsList) ? optionsList?.length : 0}
        loader={
          <Typography customClass="loading-text">
            Fetching customers ...
          </Typography>
        }
      >
        {optionsList?.length === 0 || !Array.isArray(optionsList) ? (
          <div className="no-options">
            <Typography>
              {inputValue?.length === 0
                ? "Type to search"
                : isSearching
                ? "Fetching data ..."
                : "No Options"}
            </Typography>
          </div>
        ) : (
          optionsList?.map((option, i) => (
            <div
              key={i}
              onMouseDown={(e) => {
                e.preventDefault(); // Prevent the input value from changing on click
                setValue(option);
                handleSelect(option);
              }}
              className={`custom-option${
                option?.value === value?.value ? " active-option" : ""
              }`}
            >
              <Typography size="heading-sm" tag="h6">
                {option?.title}
              </Typography>
              <Typography size="text-md" weight="medium">
                {option?.subtitle}
              </Typography>
            </div>
          ))
        )}
      </InfiniteScroll>
    </div>
  );
};
